export default (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    // One control height for the whole row — buttons and fields alike.
    '& .MuiButton-root, & .MuiOutlinedInput-root': {
      height: 35,
    },
  },
  dense: {
    '& .MuiButton-root, & .MuiOutlinedInput-root': {
      height: 32,
    },
  },
  search: {
    display: 'flex',
    flexGrow: ({ searchWidth }) => (searchWidth ? 0 : 1),
    width: ({ searchWidth }) => searchWidth,
  },
  spacer: {
    flexGrow: 1,
  },
  filtersButton: {
    // Icon-only square button below lg, so the toolbar stays a single row next to the search field.
    flex: '0 0 auto',
    padding: theme.spacing(0, 1.25),
    textTransform: 'none',
    whiteSpace: 'nowrap',
    // Mirrors the People grid: two of twelve columns minus their share of the gutter.
    [theme.breakpoints.up('lg')]: {
      flex: `0 0 calc(${(100 / 6).toFixed(3)}% - ${(theme.spacing(2) * 5) / 6}px)`,
      padding: theme.spacing(0.75, 2),
    },
  },
  filtersIcon: {
    fontSize: 16,
    color: theme.palette.textColor.grey,
    [theme.breakpoints.up('lg')]: {
      marginRight: theme.spacing(1.25),
    },
  },
  filtersLabel: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'inline',
    },
  },
});
